module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collisions shadow text-dark"
  }, [_c('div', {
    staticClass: "collisions__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['double_bookings']) + ", " + _vm._s(_vm.formattedDate))]), _vm._v(" "), _c('div', {
    staticClass: "collisions__date-changer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('prevDay')
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left4"
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('nextDay')
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right4"
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "collisions__content"
  }, [_c('li', {
    staticClass: "collisions__lesson collisions__lesson__header"
  }, [_c('div', [_vm._v(_vm._s(_vm.collisions.length) + " "), (_vm.collisions.length === 1) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['double_booking']))]) : _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['double_bookings']))])])]), _vm._v(" "), (_vm.isLoading) ? _c('li', {
    staticClass: "collisions__loader"
  }, [_c('Loader', {
    attrs: {
      "bg-color": "#fff"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsWithOverlappingEvents.length < 1) ? _c('li', {
    staticClass: "collisions__lesson text-explainer"
  }, [_vm._v("\n      " + _vm._s(_vm.i18n[_vm.locale]['no_double_bookings']) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsWithOverlappingEvents), function(event) {
    return _c('li', {
      key: event.event_id,
      staticClass: "collisions__lesson",
      style: ({
        'border-left-color': event.color
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeEvent = event
        }
      }
    }, [_c('div', [_vm._v("\n        " + _vm._s(event.v_start) + " - " + _vm._s(event.v_end) + " | "), _c('b', [_vm._v(_vm._s(event.title))]), _vm._v(", "), _c('i', [_vm._v(_vm._s(event.v_owner_calendar_name))])]), _vm._v(" "), _c('div', {
      staticClass: "overlapping-calendars"
    }, [_vm._l((event.v_overlapping_cals_with_events), function(overlappingCalendar) {
      return (overlappingCalendar.idx < 3) ? _c('div', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            zIndex: '999999992',
            boundary: 'window'
          }),
          expression: "{\n               arrow: true,\n               zIndex: '999999992',\n               boundary: 'window'}"
        }],
        key: overlappingCalendar.calendar.id,
        staticClass: "overlapping-calendar shadow",
        attrs: {
          "content": overlappingCalendar.lessons.map(function (overlappingCalendarEvent) { return overlappingCalendarEvent.v_event_title; })
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.activeCalendar = overlappingCalendar.calendar
          }
        }
      }, [_c('span', {
        staticClass: "icon-warning"
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(overlappingCalendar.calendar.name ? overlappingCalendar.calendar.name : ''))])]) : _vm._e()
    }), _vm._v(" "), (event.v_number_of_overlapping_events > 3) ? _c('div', [_vm._v("\n          + " + _vm._s(event.v_number_of_overlapping_events - 3) + " " + _vm._s(_vm.i18n[_vm.locale]['more']) + "\n        ")]) : _vm._e()], 2)])
  })], 2), _vm._v(" "), (_vm.activeCalendar) ? _c('CalendarViewDay', {
    attrs: {
      "date": _vm.date,
      "calendar": _vm.activeCalendar
    },
    on: {
      "close": function($event) {
        _vm.activeCalendar = null
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "zoomIn"
    }
  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
    attrs: {
      "event": _vm.activeEvent,
      "initCalendarId": _vm.activeEvent.calendar_id,
      "showSettings": false
    },
    on: {
      "updated": _vm.readCollisions,
      "close": _vm.closeShowEvent
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-651817b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collisions/Collisions.vue
// module id = 1637
// module chunks = 1